export default {
  labels: {
    signed_by: 'Ondertekend door {{name}} op {{date}}',
    signed_by_no_date: 'Ondertekend door {{name}}',
  },
  buttons: {
    retry: 'Opnieuw proberen',
  },
  errors: {
    load_failed: 'Het contract kon niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
  },
};
